import { FC } from 'react';
import React from 'react';

export const OOP: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vQmimn-AuX2lnr5iN4EbDzIwE0413cAZKTDD9aUcCX1EBDt8PwytL_kMQwb686KulbMSdIXy8fkda34/embed?start=false&loop=false&delayms=3000" allowFullScreen 
                width="1200" height="675">
                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};
